import { useScoringLogRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetScoringLogCommonInfoQuery } from "../../features/identity/scoringApi";
import { ManualScoring } from "./manualScoring";

export { useScoringLogRoutes };

export default GetDefaultIndex({
  title: "سوابق امتیازدهی",
  query: useGetScoringLogCommonInfoQuery,
  extra: null,
  tabs: [{ title: "امتیازدهی دستی", key: "manualScoring", content: () => <ManualScoring /> }],
});
